/**
 * <s-share> opens the native share sheet for the current product, falling back to
 * copying the link and briefly swapping the label to a "copied" message.
 */
class SShare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.label = this.querySelector('[data-share-label]');
    this.onClick = this.share.bind(this);
    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    clearTimeout(this.timer);
  }

  async share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;
    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      if (!this.label) return;
      const original = this.label.textContent;
      this.label.textContent = this.dataset.copied || original;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.label.textContent = original;
      }, 2000);
    } catch (error) {
      // The shopper dismissed the share sheet or clipboard access was denied.
    }
  }
}

if (!customElements.get('s-share')) customElements.define('s-share', SShare);
